import { Controller } from '@hotwired/stimulus';
import "bootstrap";  // Ensure Bootstrap is imported

export default class extends Controller {
  connect() {
    var element = this.element
    // Bootstrap strips `sanitize`/`whiteList`/`sanitizeFn` from data attributes for security,
    // so it must be passed here as a real JS option instead of via data-sanitize on the element.
    var options = element.dataset.disableSanitize === 'true' ? { sanitize: false } : {}
    $(element).popover(options);

    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    document.addEventListener('click', this.handleOutsideClick)
  }

  handleOutsideClick(event) {
    if (this.element.contains(event.target)) return
    if (event.target.closest('.popover')) return
    $(this.element).popover('hide')
  }

  disconnect() {
    // Clean up popovers when the controller is disconnected
    $(this.element).popover('dispose');
    document.removeEventListener('click', this.handleOutsideClick)
  }
}